import { Component, Input, OnInit } from '@angular/core';
import { LocalStorage } from '@core/localstorage';

@Component({
    selector: 'app-call-to-action',
    templateUrl: './call-to-action.component.html',
    styleUrls: ['./call-to-action.component.scss'],
})
export class CallToActionComponent implements OnInit {
    urlImageDefault: string = '/assets/images/bg_call_to_action.jpg';
    @Input('urlImage') urlImage: string = this.urlImageDefault;
    @Input('title') title: string;
    @Input('description') description: string;
    @Input('buttonText') buttonText: string;
    link: string = '/auth/register';
    @Input('link') set l(link) {
        if (link) {
            this.link = link;
        }
    }
    @Input('queryParams') queryParams: string;

    constructor(private localStorage: LocalStorage) {}

    ngOnInit(): void {
        if (this.localStorage.isPickleball()) {
            this.urlImage = '/assets/images/filiation_pickleball.png';
        }
    }
}
